export default "__VITE_ASSET__DR2sNv1O__"